import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import '../css/App.output.css';
import { DropboxPaperEditor } from '@withfriendsco/wf-components';
const DesignEditorApp = ({ alias, value: propValue, inputSelector }) => {
    const inputEl = useMemo(() => {
        if (!inputSelector || typeof document === 'undefined')
            return null;
        try {
            return document.querySelector(inputSelector);
        }
        catch (_a) {
            return null;
        }
    }, [inputSelector]);
    const [value, setValue] = useState(() => {
        if (propValue !== undefined)
            return propValue;
        const fromDom = inputEl && 'value' in inputEl ? inputEl.value : '';
        return fromDom || '';
    });
    useEffect(() => {
        if (propValue !== undefined && propValue !== value) {
            setValue(propValue);
        }
    }, [propValue]);
    const handleChange = useCallback((change) => {
        setValue(change.html);
        console.log('change', change);
        console.log('inputEl', inputEl);
        if (inputEl && 'value' in inputEl) {
            try {
                ;
                inputEl.value = change.html;
                inputEl.dispatchEvent(new Event('input', { bubbles: true }));
                inputEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
            catch (_a) {
                // no-op
            }
        }
    }, [inputEl]);
    return (_jsx("div", { id: "tw-root", children: _jsx("div", { id: "tw-main", className: "App container-fluid p-4", children: _jsx(DropboxPaperEditor, { value: value, onChange: handleChange, className: "max-w-3xl", toolbarClassName: "bg-wfGray-50", contentClassName: "min-h-[300px]", uploadcarePublicKey: process.env.REACT_APP_UPLOADCARE_PUBLIC_KEY }) }) }));
};
export default DesignEditorApp;
